import React from "react";

const VerificationIcon = ({
  width = 46,
  height = 46,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="44" height="44" rx="22" fill="#133345" />
      <rect x="1" y="1" width="44" height="44" rx="22" stroke="#E2E4E9" />
      <path
        d="M31.0984 19.4V31.0937C31.0993 31.2119 31.0768 31.3291 31.0323 31.4386C30.9879 31.5481 30.9223 31.6478 30.8393 31.7319C30.7563 31.8161 30.6576 31.8831 30.5487 31.9291C30.4398 31.9751 30.3229 31.9992 30.2047 32H15.7921C15.5553 32 15.3281 31.906 15.1605 31.7386C14.9929 31.5712 14.8987 31.3441 14.8984 31.1072V14.8928C14.8984 14.4095 15.3025 14 15.8002 14H25.6957L31.0984 19.4ZM29.2984 20.3H24.7984V15.8H16.6984V30.2H29.2984V20.3ZM19.3984 18.5H22.0984V20.3H19.3984V18.5ZM19.3984 22.1H26.5984V23.9H19.3984V22.1ZM19.3984 25.7H26.5984V27.5H19.3984V25.7Z"
        fill="white"
      />
    </svg>
  );
};

export default VerificationIcon;
